import { Button } from 'fitify-ui-onboarding/src/components/GenderFunnel/Button/Button'
import { StyledPlanTileContainer } from 'fitify-ui-onboarding/src/components/Paywall/Plan/Plan.Styled'
import { Segment } from 'fitify-ui-onboarding/src/components/Paywall/Segment/Segment'
import { SegmentLoader } from 'fitify-ui-onboarding/src/components/Paywall/Segment/SegmentLoader'
import { useTranslation } from 'next-i18next/pages'

type Props = {
  planTitle?: string
}

export const PlanLoader = ({ planTitle }: Props) => {
  const { t } = useTranslation()

  return (
    <Segment title={planTitle || t('paywall_your_plan_is_ready_calisthenics')}>
      <StyledPlanTileContainer>
        <SegmentLoader style={{ height: '102px' }} />
        <SegmentLoader style={{ height: '102px' }} />
        <SegmentLoader style={{ height: '102px' }} />
      </StyledPlanTileContainer>
      <Button isDisabled isLoading>
        {t('paywall_cta_get_my_plan')}
      </Button>
    </Segment>
  )
}
